export default "__VITE_ASSET__7fr0907k__"